const Utils = {

  /**
   * Reduces an array of objects into smaller groups.
   * This is useful for example when needing to wrap cols in rows.
   *
   * @param size number e.g. 2
   * @param items array e.g. [Car, Car, Car, Car, Car]
   */
  groupItems(size, items) {
    return items.reduce(
      (items, item, index) => {
        if (index % size === 0) {
          items.push([]);
        }

        items[items.length - 1].push(item);

        return items;
      },
      []
    );
  },

  /**
   * Forces a string's first character to be uppercase, leaves the rest untouched.
   *
   * @param string e.g. "hello"
   *
   * @return string e.g. "Hello"
   */
  ucFirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },

  /**
   *  Basic method for adding seperation characters to numbers.
   *  This is a basic string method, so numbers starting with 0s will not get the correct result.
   *
   * @param amount - Number e.g. 85756
   *
   * @return string e.g. "85.756"
   */
  addCommasToNumber(amount, seperator = '.') {
    const arr = amount.toString().split('');

    if (arr.length < 4) {
      return arr.join('');
    }

    const start = 0;
    const end = arr.length - 1;
    var n = 0;
    var i = arr.length - 1;
    var outputArr = [];

    while (i >= start) {
      if (n % 3 === 0 && n !== start && n !== end) {
        outputArr.push(seperator);
      }
      outputArr.push(arr[i]);
      n++;
      i--;
    }

    return outputArr.reverse().join('');
  },

  /**
   * Calculates the number of days between two dates. Assumes all days are 24h (technically some aren't).
   *
   * @param start Date
   * @param end Date
   *
   * @return Number e.g. 784
   */
  getNumberOfDaysBetweenDates(start, end) {
    const oneDay = 24*60*60*1000;

    return Math.round(Math.abs((start.getTime() - end.getTime())/(oneDay)));
  }
}

export { Utils };
